import { styled, css } from 'styles';
import { Fieldset } from '@unmind/design-system-components-web';
import { rem } from 'polished';
import Label from 'Shared/Form/Label';
import { medium } from '../../../utils';

export const Panel = styled.div`
  ${medium(css`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  `)}
`;

export const RadioContainer = styled(Fieldset)`
  margin-right: 3rem;

  > label:first-of-type {
    margin-right: ${rem(24)};
  }

  > label {
    font-size: ${({ theme }) => theme.typography.fontSizes.fontSize18}px;
    margin-bottom: ${rem(14)};
    margin-top: ${rem(8)};
    ${medium(css`
      margin-top: ${rem(14)};
    `)}
  }
`;

export const FilterLabel = styled(Label)`
  display: inline-flex;
  ${medium(css`
    margin-bottom: ${rem(8)};
  `)}
`;
